export const FOCUSABLE_ERROR_INPUT_CLASS = 'focusable-error-input';
